import { cn } from '@/lib/utils'
import { useTheme } from '@/theme/useTheme'

export default function BrandingAttribution({ className }) {
  const { branding } = useTheme()
  if (!branding.show_graphit_branding) return null
  return <p className={cn('text-xs text-ink-2', className)}>Powered by Graphit</p>
}
